import React from 'react';
import {Box} from '@chakra-ui/react';
import Header from './Header';
import {MultipleChartsView} from '../features/views/MultipleChartsView';
import {ChartContainer} from '../common/ui';
import {COLORS} from '../../config/UIConstants';
import { MultipleChartsProvider } from '../common/AstrologyChart/MultipleChartsContext';
import { SharedChartData, SharedViewMode } from '../../types/share.types';
import './MainLayout.css';

interface MainLayoutProps {
    shareMode?: boolean;  // If true, disable Data menu, Sidebar, and tab creation
    sharedChartData?: SharedChartData;  // Chart data for share mode
    sharedViewMode?: SharedViewMode;  // View mode for shared charts (author/guest)
    onSharedViewModeChange?: (mode: SharedViewMode) => void;  // Callback for view mode change
}

/**
 * Main layout component - Multiple Charts Architecture v4.0.0
 * With header and tabbed chart interface
 * Note: All sections are always visible in shareMode
 */
const MainLayout: React.FC<MainLayoutProps> = ({
    shareMode = false,
    sharedChartData,
    sharedViewMode,
    onSharedViewModeChange
}) => {

    return (
        <MultipleChartsProvider>
            <Box
                className="main-layout"
                bg={COLORS.background}
            >
                {/* Header - Connected to MultipleChartsContext */}
                <Header
                    shareMode={shareMode}
                    isAuthor={sharedChartData?.is_author}
                    sharedViewMode={sharedViewMode}
                    onSharedViewModeChange={onSharedViewModeChange}
                />

                {/* Multiple Charts Interface */}
                <Box
                    className="main-layout-content"
                    bg={COLORS.background}
                >
                    <ChartContainer
                        width="100%"
                        py={0}
                        height="calc(100vh - 44px)"
                    >
                        <MultipleChartsView
                            key={`charts-view-${sharedViewMode}`}
                            showDetails={true}
                            detailsPosition="right"
                            shareMode={shareMode}
                            sharedChartData={sharedChartData}
                            sharedViewMode={sharedViewMode}
                        />
                    </ChartContainer>
                </Box>
            </Box>
        </MultipleChartsProvider>
    );
};

export default MainLayout;